import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { map, Observable } from 'rxjs';

import { CB2_PREVIEW_BLOC_KEY } from './cb2-preview-bloc-key.token';
import { Cb2PreviewStateService } from './cb2-preview-state.service';
import type { Cb2PreviewScenarioPayload } from './cb2-preview-protocol';

export function previewScenarioForBloc$(
  componentType: string,
): Observable<Cb2PreviewScenarioPayload | null> {
  const previewState = inject(Cb2PreviewStateService);
  const blocKey = inject(CB2_PREVIEW_BLOC_KEY, { optional: true });

  return toObservable(previewState.previewScenarios).pipe(
    map(scenarios => resolvePreviewScenarioForBloc(scenarios, blocKey, componentType)),
  );
}

export function resolvePreviewScenarioForBloc(
  scenarios: Readonly<Record<string, Cb2PreviewScenarioPayload>>,
  blocKey: string | null | undefined,
  componentType: string,
): Cb2PreviewScenarioPayload | null {
  if (blocKey) {
    const scenario = scenarios[blocKey];
    if (scenario?.blocType === componentType) {
      return scenario;
    }
  }

  const legacyMatch = Object.values(scenarios).find(
    scenario => scenario.blocType === componentType,
  );
  return legacyMatch ?? null;
}
